const $ = require('jquery');
global.$ = global.jQuery = $;

// require('slick-carousel');
// require('slick-carousel/slick/slick.css');
// require('slick-carousel/slick/slick-theme.css');

require('bootstrap');




// // Import Swiper core & modules
// import Swiper from "swiper";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import "swiper/css/effect-fade"; // Nếu muốn dùng hiệu ứng fade
// import "swiper/css/lazy";

// import { Navigation, Pagination, Autoplay, EffectFade, Lazy } from "swiper/modules";
// Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Lazy]);

// new Swiper("#swiperTopPage-content01", {
//     direction: "horizontal",
//     autoplay: {
//         delay: 4000,
//         disableOnInteraction: false,
//         waitForTransition: true,
//     },
//     speed: 2000,
//     loop: true,
//     spaceBetween: 10,
//     slidesPerView: 1.1,
//     centeredSlides: true,
//     slidesPerGroup: 1,
//     observer: true,
//     observeParents: true,
//     lazy: {
//         loadPrevNext: true,
//     },
//     effect: "fade", // hoặc "slide"
//     fadeEffect: { crossFade: true },
//     pagination: {
//         el: ".swiper-pagination-content01",
//         clickable: true,
//     },
//     breakpoints: {
//         769: {
//             spaceBetween: 30,
//             slidesPerView: 1.36,
//         },
//     },
// });
